import { Injectable } from '@angular/core';

@Injectable()
export class TranslatorService {

    private defaultLanguage: string = 'en';

    private availablelangs = [
        { code: 'en', text: 'English' },
        //{ code: 'es_AR', text: 'Spanish' }
    ];

    constructor() {

        this.useLanguage();

    }

    useLanguage(lang: string = null) {
    }

    getAvailableLanguages() {
        return this.availablelangs;
    }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/core/translator/translator.service.ts